"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBarFilterWidget = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons/");

var _SelectFilter = _interopRequireDefault(require("./SelectFilter"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SearchBarFilterWidget = function SearchBarFilterWidget(props) {
  var handleSearchTerm = props.handleSearchTerm,
      searchPlaceHolder = props.searchPlaceHolder,
      filterOptions = props.filterOptions,
      defaultFilterOption = props.defaultFilterOption,
      inputWrapperClass = props.inputWrapperClass,
      isToHide = props.isToHide,
      responsiveHidden = props.responsiveHidden,
      handleShowSearch = props.handleShowSearch,
      handleHideSearch = props.handleHideSearch,
      isShowSearch = props.isShowSearch;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTyping = _useState2[0],
      setIsTyping = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultFilterOption),
      _useState6 = _slicedToArray(_useState5, 2),
      filterOption = _useState6[0],
      setFilterOption = _useState6[1];

  var saraivaTheme = (0, _core.useTheme)();
  var isDesktop = (0, _core.useMediaQuery)(saraivaTheme.breakpoints.up('sm'));
  var classes = (0, _styles.default)();

  var handleOnSubmit = function handleOnSubmit(filter) {
    if (!isDesktop) {
      handleHideSearch();
    }

    handleSearchTerm({
      filterTerm: inputValue,
      filterName: filter.value || defaultFilterOption
    });
  };

  var handleOnKeyDown = function handleOnKeyDown(evt) {
    if (evt.key === 'Enter') {
      handleOnSubmit(filterOption);
    }
  };

  var clearSearch = function clearSearch() {
    setIsTyping(!isTyping);
    setInputValue('');
    handleHideSearch();
  };

  var handleSearchChange = function handleSearchChange(evt) {
    setInputValue(evt && evt.target.value);

    if (evt && evt.target.value === '') {
      setIsTyping(false);
      handleHideSearch();
      return;
    }

    if (!isTyping) {
      setIsTyping(true);
    }
  };

  var handleOnClickInput = function handleOnClickInput(event) {
    var nodes = ['button', 'svg', 'path', 'span'];

    if (nodes.indexOf(event.target.localName) === -1) {
      handleShowSearch();
    }
  };

  var goBack = function goBack() {
    setIsTyping(false);
    handleHideSearch();
    setInputValue('');
  };

  if (isToHide) return null;

  var searchIcon = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
    position: "start"
  }, /*#__PURE__*/_react.default.createElement(_icons.SearchSharp, {
    className: classes.adornment
  }));

  var backIcon = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
    position: "start"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: goBack,
    className: classes.buttonAdornment
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowBack, {
    className: classes.adornmentBack
  })));

  var closeIcon = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
    position: "end"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: clearSearch,
    className: classes.closeButton
  }, /*#__PURE__*/_react.default.createElement(_icons.Close, {
    className: classes.adornmentRight
  })));

  return /*#__PURE__*/_react.default.createElement(_core.Hidden, responsiveHidden, isDesktop ? /*#__PURE__*/_react.default.createElement("form", {
    className: "".concat(classes.searchWrapper, " ").concat(inputWrapperClass),
    onKeyDown: handleOnKeyDown
  }, /*#__PURE__*/_react.default.createElement(_SelectFilter.default, {
    filterOptions: filterOptions,
    onOptionSelect: setFilterOption,
    option: filterOption
  }), /*#__PURE__*/_react.default.createElement(_core.Input, {
    disableUnderline: true,
    placeholder: searchPlaceHolder,
    onChange: handleSearchChange,
    value: inputValue,
    className: classes.input,
    startAdornment: searchIcon,
    endAdornment: isTyping || inputValue !== '' ? closeIcon : null
  })) : /*#__PURE__*/_react.default.createElement("form", {
    className: "".concat(classes.searchWrapper, " ").concat(inputWrapperClass),
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    },
    onKeyDown: handleOnKeyDown
  }, /*#__PURE__*/_react.default.createElement(_core.Input, {
    id: "input-search-filter-mobile",
    disableUnderline: true,
    placeholder: searchPlaceHolder,
    onChange: handleSearchChange,
    value: inputValue,
    onClick: handleOnClickInput,
    className: classes.input,
    startAdornment: isShowSearch ? backIcon : searchIcon,
    endAdornment: isTyping || inputValue !== '' ? closeIcon : null
  }), isShowSearch && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.menuContainer
  }, filterOptions && inputValue.length && filterOptions.map(function (filter, index) {
    var label = filter.label;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      style: {
        marginTop: index < 1 && 24
      },
      className: classes.filterItem,
      onClick: function onClick() {
        return handleOnSubmit(filter);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      className: classes.filterValue
    }, inputValue), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.filterLabel
    }, "em ".concat(label))), /*#__PURE__*/_react.default.createElement(_core.Divider, {
      className: classes.divider
    }));
  }))));
};

exports.SearchBarFilterWidget = SearchBarFilterWidget;
SearchBarFilterWidget.propTypes = {
  /** Função de busca a ser executada */
  handleSearchTerm: _propTypes.default.func.isRequired,

  /** Texto do placeholder do input */
  searchPlaceHolder: _propTypes.default.string,

  /** Lista de opções para o filtro select */
  filterOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string || _propTypes.default.number
  })),

  /** Opção selecionada no filtro */
  defaultFilterOption: _propTypes.default.string,

  /** Função com classes */
  inputWrapperClass: _propTypes.default.string,

  /** Flag de curto-circuito para esconder o widget */
  isToHide: _propTypes.default.bool,

  /**
   * Propriedades para controlar quando esconder um objeto usa a mesma api do Componente do MUI Hidden
   * {@link https://v4.mui.com/components/hidden/#hidden [Detalhes]}
   */

  /** Valor do search */
  value: _propTypes.default.string,

  /** Tamanho definido para esconder props de bottomWidget */
  responsiveHidden: _propTypes.default.shape({
    lgDown: _propTypes.default.bool,
    lgUp: _propTypes.default.bool,
    mdDown: _propTypes.default.bool,
    mdUp: _propTypes.default.bool,
    only: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
    smDown: _propTypes.default.bool,
    smUp: _propTypes.default.bool,
    xlDown: _propTypes.default.bool,
    xlUp: _propTypes.default.bool,
    xsDown: _propTypes.default.bool,
    xsUp: _propTypes.default.bool
  }),

  /** Função responsável por exibir o showSearch em Mobile ao clicar no bottomWidgetProps
   */
  handleShowSearch: _propTypes.default.func,

  /** Função responsável por esconder o showSearch em Mobile ao clicar no bottomWidgetProps
   */
  handleHideSearch: _propTypes.default.func,

  /** Booleano responsável por exibir ou não o drawer com items do filtro, no mobile */
  isShowSearch: _propTypes.default.bool
};
SearchBarFilterWidget.defaultProps = {
  searchPlaceHolder: 'Buscar...',
  filterOptions: [{
    label: '',
    value: ''
  }],
  defaultFilterOption: 'todos',
  inputWrapperClass: null,
  isToHide: false,
  responsiveHidden: {
    lgDown: false,
    lgUp: false,
    mdDown: false,
    mdUp: false,
    only: null,
    smDown: false,
    smUp: false,
    xlDown: false,
    xlUp: false,
    xsDown: false,
    xsUp: false
  },
  handleShowSearch: function handleShowSearch() {
    return null;
  },
  handleHideSearch: function handleHideSearch() {
    return null;
  },
  isShowSearch: false,
  value: ''
};